<template>
  <div>
    <div class="dialogBox" >
      <el-dialog title="Change Password"   :visible.sync="showDialog"  @close="clkCloseBtn" :close-on-click-modal="false" custom-class="borRad10 " width="540px">
        <div style="padding:0 25px">
          <el-form :model="user" :rules="rules" ref="user" label-width="100px" class="resetCss setpass" label-position="top">
            <el-form-item label="Enter Current Password" prop="lastPass">
              <el-input type="password" v-model="user.lastPass" ></el-input>
            </el-form-item>
            <el-form-item label="Enter New Password" prop="newPass">
              <el-input type="password" v-model="user.newPass" ></el-input>
            </el-form-item>
            <el-form-item label="Confirm Your New Password" prop="checkPass">
              <el-input type="password" v-model="user.checkPass"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align:center;" class="marTop10 ">
                <a class="lineBlue30 marR20" @click="clkCloseBtn">CANCAL</a>
                <a class="blueBtn30" @click="submitForm('user')">SUMBIT</a>
              </div>
            </el-form-item>
          </el-form>   
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import { elAlert } from '@/utils/bulletBox'
export default {
  data() {
    return {
      showDialog:false,
      userInfo:{},
      user:{
        lastPass:'',
        newPass:'',
        checkPass:'',
      },
      rules: {
        newPass: [
          { validator: this.checkFormat, trigger: 'blur' ,required: true,}
        ],
        checkPass: [
          { validator: this.checkAgain, trigger: 'blur' ,required: true,}
        ],
        lastPass: [
          { validator: this.beforePass, trigger: 'blur' ,required: true,}
        ]
      }
    }
  },
  mounted() {

  },
  created() {

  },
  methods:{
      //显示弹窗  传入用户信息
    clkDialog(userInfo){
      this.showDialog=true
      if (this.$refs['user']!==undefined) {
        this.$refs['user'].resetFields();
      }
    },
    //关闭弹窗
    clkCloseBtn(){
      this.showDialog=false
    },
    async checkFormat(rule, value, callback) {
      var reg = /^.{6,20}$/;
      if (value === '' || value === null) {
        callback(new Error('New password is required'));
      } else if (!reg.test(value)) {
        callback(new Error('Please enter 6-20 characters using alphanumeric, numeric or symbolic.'));
      }  else {
        if (this.user.checkPass !== '') {
          this.$refs.user.validateField('checkPass');
        }
        callback();
      }
    },
    async beforePass(rule, value, callback) {
      var reg = /^.{6,20}$/;
      if (value === '' || value === null) {
        callback(new Error('Current password is required'));
      } else if (!reg.test(value)) {
        callback(new Error('Please enter 6-20 characters using alphanumeric, numeric or symbolic.'));
      }  else {
        callback();
      }
    },
    async checkAgain (rule, value, callback){
      var reg = /^.{6,20}$/;
      if (value === '') {
        callback(new Error('password confirmation is required'));
      } else if (!reg.test(value)) {
        callback(new Error('Please enter 6-20 characters using alphanumeric, numeric or symbolic.'));
      } else if (value !== this.user.newPass) {
        callback(new Error("Password confirmation doesn't match Password"));
      } else {
        callback();
      }
    },
    // 校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.UpdatePass()
        } else {
          return false;
        }
      });
    },
    // 更新密码接口
    UpdatePass() {
      let url = this.$api02 + '/api/EbayCustomer/CustomerInfoPwd/UpdateLogInPwd';
      let param = {
        "Password": this.user.lastPass,
        "NewPassword": this.user.checkPass,
      }
      post(url, param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          elAlert(this,"Success!You have Updated your Password", "",).then(()=>{
            this.clkCloseBtn()
          }).catch(()=>{
            this.clkCloseBtn()
          })
        } else if (res.ErrorCode == 'C0002') {
          elAlert(this,"Current password is not correct", "",)
        } else {
          elAlert(this,"Password modification failed", "",)
        }
      })
    },

  }
}
</script>
<style>
.addChild .el-form-item__label{font-size: 12px !important;padding: 0;color: #000;font-weight: bold;}
.addChild .el-form-item{margin-bottom:8px;}
.addChild .el-form-item .el-input__inner{font-size: 12px;}
.addChild .el-form-item .el-form-item__error{color: red!important}
.addChild .el-form-item.is-error .el-input__inner{border-color: red!important}
.addChild .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{color: red!important}

</style>
<style scoped>
.lineBlue30{display: inline-block; width: 100px;font-size: 12px; height: 28px;line-height: 28px;text-align: center;    border: 1px solid #004FB1;border-radius: 30px;background-color: #fff;color: #004FB1 !important;}
.blueBtn30{display: inline-block; width: 100px;font-size: 12px; height: 28px;line-height: 28px;text-align: center;    border: 1px solid #004FB1;border-radius: 30px;background-color: #004FB1;color: #fff !important;}
.addChild{ padding: 10px 12px 0 12px;}
.add-rInput{width: 300px;font-size:12px}
.add-leftName{display: inline-block;width: 140px;text-align: right;font-size:12px;color: #000;font-weight: bold;}

</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/basicInfo/updatePass.vue